/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{loadPanelContentComponents as t,PanelContentMessage as e,PanelContent as o}from"./PanelContent.js";import"../../support/widgetUtils.js";import{tsx as n}from"../../support/jsxFactory.js";const r=()=>t();function s({helpMessage:t}){return n(o,{key:"creating-features-panel-content"},n(e,{key:"content-message"},t))}export{s as CreateFeaturesPanelContent,r as loadCreateFeaturesPanelContentComponents};
